import { DateTime } from 'luxon';
import { isUndefined, thenElse } from 'dg-web-shared/lib/MaybeV2.ts';
import { Translation } from '../../common/i18n/Text.ts';
import * as PermitCreateTexts from '../i18n/PermitCreateTexts.ts';
import * as PermitCreateState from '../state/PermitCreateState.ts';
import * as PermitTypeState from '../../common/state/PermitTypeState.ts';
import { Store, useStore } from 'dg-web-shared/lib/Flux.tsx';
import { DatePickerSlideIn } from '../../ui/slidein/DatePickerSlideIn.tsx';
import { useLanguage } from 'dg-web-shared/lib/Localization.tsx';

export interface Texts {
    FromCaption: Translation;
}

export function PermitCreateValidityFromDateSlideIn() {
    const { storeState, update } = useStore(store => ({
        layout: PermitCreateState.Layout.get(store),
        config: PermitCreateState.Config.get(store),
        permitType: PermitTypeState.getById(
            store,
            PermitCreateState.Config.get(store).permitTypeId,
        ),
        calc: PermitCreateState.Calc.get(store),
    }));
    const { language } = useLanguage();

    function txt(): Texts {
        return PermitCreateTexts.validityFromDate[language];
    }

    function onDateSelected(selectedDate: DateTime): void {
        update((store: Store): string => {
            PermitCreateState.Config.stateWrite(store, {
                startDate: selectedDate,
            });
            PermitCreateState.Layout.stateWrite(store, {
                validityFromDatePickerOpen: false,
            });
            PermitCreateState.Calc.reset(store);
            return 'PermitCreateValidityFromDateSlideIn-selectDate';
        });
    }

    const permitType = storeState.permitType;

    if (isUndefined(permitType)) {
        return null;
    } else {
        // don't allow selection of date after selected end date
        const maxDate = thenElse(
            storeState.config.endDate,
            endDate =>
                endDate < permitType.fromRange.end
                    ? endDate
                    : permitType.fromRange.end,
            permitType.fromRange.end,
        );

        return (
            <DatePickerSlideIn
                open={storeState.layout.validityFromDatePickerOpen}
                caption={txt().FromCaption()}
                onClose={() =>
                    update(store =>
                        PermitCreateState.Layout.stateWrite(store, {
                            validityFromDatePickerOpen: false,
                        }),
                    )
                }
                selectedDate={
                    storeState.calc.data?.validFrom ??
                    storeState.config.startDate
                }
                onSelect={(selectedDate: DateTime) =>
                    onDateSelected(selectedDate)
                }
                minDate={permitType.fromRange.start}
                maxDate={maxDate}
                language={language}
                outsideBody
            />
        );
    }
}
